// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BW-z","inlineTitle":"CW-z","sponsoredAdsWrapper":"DW-z","marketplaceRecosWrapper":"EW-z"};